var stringUtils = require('src/interlock/no-ui/utils/string/string');

function getSelectedData() {
    var selectedVins = $('.lead-form-pricing .custom-control.inventory-checkbox')
        .filter(function (index, el) {
            return $(el).find('input:checked').length === 1;
        })
        .find('.suggestion')
        .get()
        .map(function (el) {
            return  {
                vin: el.dataset.vin,
                gpExpirationDate: el.dataset['expiration'],
                dealer:el.dataset.rooftopId,
                franchise:el.dataset.franchiseId,
                position: el.dataset.position,
                leadType: el.dataset.leadType,
                make:el.dataset.make,
                styleId:el.dataset.styleId
            };
        });

    return selectedVins;
}

function getInventoryCount() {
    return $('.lead-form-pricing:visible .custom-control.inventory-checkbox .suggestion').length;
}

function claimAllSelectedDealersQuotes() {
    var formWrap = $('.lead-form-pricing');
    var allCards = formWrap.find('.suggestions .gray-bottom');
    var defaultElem = formWrap.find('.default');
    var backupElem = formWrap.find('.backup');
    var largestSavings = 0;
    var totalPP = 0;

    allCards.each(function() {
        if ($( this ).find('.invCheckbox').prop('checked')) {
            var savings = 0;
            var msrp = $( this ).find('.suggestion').data('msrp');
            var pp = $( this ).find('.suggestion').data('pp');
            if (msrp && pp) {
                totalPP++;
                savings = msrp - pp;
                if (savings > largestSavings) {
                    largestSavings = parseInt(savings, 10);
                }
            }
        }
    });

    if (defaultElem) {
        if (largestSavings && totalPP >= 2) {
            $('.lead-form-pricing').find('.savingsMsg').html(stringUtils.formatAsUsPrice(largestSavings, 'N/A'));
            defaultElem.css('display', 'block');
            backupElem.css('display', 'none');
        } else {
            defaultElem.css('display', 'none');
            backupElem.css('display', 'block');
        }
    }
}

function addCheckboxHandler(form) {
    var leadForm = form.closest('.lead-form-pricing');

    leadForm.on('change', '.suggestions .custom-checkbox', function () {
        var selectDealerErrorEl = form.find('.select-dealer-error');
        var seePricesButton = form.find('.btn-success');
        var selData = getSelectedData();
        if(selData.length) {
            selectDealerErrorEl.addClass('hidden-xs-up');
            seePricesButton.prop('disabled', false);
        }
    });
}

function calcSavings() {
    claimAllSelectedDealersQuotes();
    var inventoryWrap = document.querySelector('.suggestions');
    inventoryWrap.addEventListener('click', function (e) {
        if (e.target.classList.contains('invCheckbox')) {
            claimAllSelectedDealersQuotes();
        }
    });
}

module.exports = {
    getSelectedData: getSelectedData,
    getInventoryCount: getInventoryCount,
    addCheckboxHandler: addCheckboxHandler,
    calcSavings: calcSavings
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/pricing-lead-form/pricing-lead-form-helper.js
// module id = 151
// module chunks = 0 1 16 19